<template>
  <div class="app" v-cloak>
    <template v-if="shopSeq">
      <router-view></router-view>
      <confirm-modal></confirm-modal>
      <alert-modal></alert-modal>
    </template>
    <spinner></spinner>
  </div>
</template>

<script>
import ConfirmModal from '@/views/base/ConfirmModal'
import AlertModal from '@/views/base/AlertModal'
import Spinner from '@/views/base/Spinner'
import { mapGetters, mapActions } from 'vuex'
import { isInIframe } from '@/utils'

export default {
  name: 'app',
  components: {
    ConfirmModal,
    AlertModal,
    Spinner
  },
  computed: {
    ...mapGetters('main', ['shopSeq'])
  },
  methods: {
    ...mapActions('main', ['getInitData'])
  },
  mounted() {
    this.getInitData()
    if (isInIframe()) {
      document.body.classList.add('in_iframe')
    }
  }
}
</script>

<style lang="scss">
@import 'assets/scss/style';
</style>
